import { render, staticRenderFns } from "./SimpleSlides.vue?vue&type=template&id=053fd00d&scoped=true&"
import script from "./SimpleSlides.vue?vue&type=script&lang=js&"
export * from "./SimpleSlides.vue?vue&type=script&lang=js&"
import style0 from "./SimpleSlides.vue?vue&type=style&index=0&id=053fd00d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053fd00d",
  null
  
)

export default component.exports